import { OpportunityReport } from "@entities";
import { CircularProgress, Stack } from "@mui/material";
import { useCreateHyperTable } from "@shared/frontend/hyper-table";
import { ActionButton } from "@shared/frontend/hyper-table/inner-components/hyper-table-actions-bar/ActionsBar";
import { isEntityFilter } from "@shared/frontend/hyper-table/inner-components/hyper-table-toolbar/FilterMenuItem";
import { type FC, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useOrganization } from "../../../contexts/OrganizationProvider";
import columns from "./columns";
import filters from "./filters";
import { TableHeaderTitles } from "../table-header/TableHeader";

const OpportunityReportTable: FC<{
  id: string;
  previewRows?: OpportunityReport[];
  tourAnchors?: boolean;
}> = ({ id }) => {
  const { HyperTable } = useCreateHyperTable(OpportunityReport);
  const { currOrganization } = useOrganization();
  const [selectedParticipants, setSelectedParticipants] = useState<
    OpportunityReport[]
  >([]);

  if (!currOrganization)
    return (
      <Stack width="100%" height="100%" paddingTop="10vh" alignItems="center">
        <CircularProgress />
      </Stack>
    );

  return (
    <HyperTable
      tableId="opportunity-report-table"
      findConfig={{
        where: OpportunityReport.hyperFilter({
          $and: [id ? { opportunity: { $id: id } } : {}],
          $or: []
        }),
        include: {
          opportunity: true,
          association: {
            include: {
              user: true
            }
          }
        }
      }}
      onRowClick={(_, row) => { }}
      title={<TableHeaderTitles titles={[{ content: "דיווחי ביצוע" }]} />}
    >
      <HyperTable.Toolbar>
        {filters.map((filter) =>
          isEntityFilter(filter) ? (
            <HyperTable.EntityFilter key={filter.id} {...(filter as any)} />
          ) : (
            <HyperTable.CustomFilter key={filter.id} {...filter} />
          ),
        )}
      </HyperTable.Toolbar>
      {columns.map((column) => (
        <HyperTable.Column key={column.field} {...column} />
      ))}
    </HyperTable>
  );
};

export default OpportunityReportTable;
